import React from 'react'
import { configCards } from '../../types'
import { ConfigCard } from './components/ConfigCard'

function IntegrationDashboard() {
  return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
      {configCards.map((card) => (
        <ConfigCard
          key={card.title}
          icon={card.icon}
          title={card.title}
          description={card.description}
          navigate={card.navigate}
        />
      ))}
    </div>
  )
}

export default IntegrationDashboard